import { invoke } from '@tauri-apps/api/core';
import type { ITransport } from '../index.js';

export class TauriTransport implements ITransport {
  public readyState: number = 0; // 0 = CONNECTING
  public onopen: (() => void) | null = null;
  public onmessage: ((evt: { data: unknown }) => void) | null = null;
  public onclose: (() => void) | null = null;
  public onerror: ((evt: unknown) => void) | null = null;
  private closed = false;

  constructor() {
    // Simulate async connection to match WebSocket behavior
    setTimeout(() => {
      if (this.closed) return;
      this.readyState = 1; // 1 = OPEN
      if (this.onopen) {
        this.onopen();
      }
    }, 0);
  }

  public send(data: string): void {
    if (this.readyState !== 1) return;

    invoke<string>('plugin:drahtzieher|invoke_draht', { payload: data })
      .then((responseStr: string) => {
        if (this.onmessage && responseStr) {
          this.onmessage({ data: responseStr });
        }
      })
      .catch((err: unknown) => {
        if (this.onerror) {
          this.onerror(err);
        }
      });
  }

  public close(): void {
    if (this.closed) return;
    this.closed = true;
    this.readyState = 3; // 3 = CLOSED
    if (this.onclose) {
      this.onclose();
    }
  }
}
